import React from 'react'
import 'styles/index.scss'
import App from 'app'
import { Provider } from 'react-redux'
import store from 'stores/store'
import * as serviceWorkerRegistration from 'serviceWorkerRegistration'
import ErrorBoundary from 'pages/_errorBoundary'
import { createRoot } from 'react-dom/client'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
    <ErrorBoundary>
        <Provider store={store}>
            <App />
        </Provider>
    </ErrorBoundary>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()
